import React, { useState } from "react";
import "./ManageServicesList.css";
import Widgets from "../../../../widgets";
import plusIcon from "../../../../Assets/Icons/PlusIcon.png";
import Icons from "../../../../Assets/Icons";
import { useTranslation } from "react-i18next";
import MRList from "./MRList";
import strings from "../../../../utils/strings";
import { useNavigate } from "react-router-dom";
import * as XLSX from "xlsx";
import { fetchServiceItems, fetchServices } from "../../../../modules/NursignCare/ManageServices/ManageServiceThunk";
import { getAllGroups, createGroup } from "../../../../modules/NursignCare/AdditonalConsumable/AddConsumableThunk";
import { useDispatch } from "react-redux";
import { createServiceItem, bulkUploadServiceItems } from "../../../../modules/NursignCare/ManageServices/ManageServiceThunk";
import ToastPopup from "../../../../widgets/Toast/toastPopup";
import BulkUploadInfoModal from "../../../../widgets/BulkUploadInfoModal/BulkUploadInfoModal";

const ManageServicesList = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const breadcrumbs = ["nursingCare", "manageService"];
  const paths = [strings.navigation.nursingCareManageService, strings.navigation.nursingCareManageService];
  const [searchValue, setSearchValue] = useState("");
  const [entrySummary, setEntrySummary] = useState({ displayed: 0, total: 0 });
  const [showBulkInfo, setShowBulkInfo] = useState(false);
  const [bulkResult, setBulkResult] = useState({ success: 0, duplicate: 0, fail: 0, createdGroup: 0 });

  const toStr = (val, def = "") => {
    if (val === null || val === undefined) return def;
    const s = String(val).trim();
    return s.length > 0 ? s : def;
  };

  const numberize = (val) => {
    const s = toStr(val);
    if (!s) return "";
    const clean = s.replace(/,/g, "");
    return /^\d+(\.\d+)?$/.test(clean) ? clean : "";
  };

  const handleFileUpload = async (file) => {
    if (!file) return;
    ToastPopup.info("Uploading file... please wait.");
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await dispatch(bulkUploadServiceItems(formData)).unwrap();

      let success = 0, fail = 0;

      if (response?.data?.created) {
        success = (response.data.created.services || 0) + (response.data.created.subServices || 0) + (response.data.created.serviceItems || 0);
      }

      if (response?.data?.skipped) {
        fail = (response.data.skipped.serviceItems?.length || 0);
      }

      setBulkResult({ success, duplicate: fail, fail: 0, createdGroup: 0 });
      setShowBulkInfo(false);
      ToastPopup.success("Bulk upload completed successfully");
      dispatch(fetchServices({ page: 1, limit: 10 }));
    } catch (error) {
      setShowBulkInfo(false);
      ToastPopup.error(typeof error === "string" ? error : error?.message || "Failed to bulk upload");
    }
  };

  return (
    <div className="mr-container">
      <Widgets.BreadCrumb breadcrumbs={breadcrumbs} paths={paths} />
      <div className="manage-service-heading">{t("services")}</div>
      <div className="manage-service-search-line">
        <Widgets.SearchBox placeholder={"searchByServiceGroup"}
          value={searchValue}
          onSearch={(value) => setSearchValue(value)}
        />
        <div className="manage-service-action-group">
          <Widgets.IconButton iconSrc={Icons.publish} buttonText={t("BulkUpload")} onClick={() => setShowBulkInfo(true)} />
          <Widgets.IconButton iconSrc={plusIcon} buttonText="addService" onClick={() => navigate(strings.navigation.createService)} />
        </div>
      </div>
      <div className="manage-service-entry-summary">
        {t("Showing")} {entrySummary.displayed} {t("entriesOf")} {entrySummary.total} {t("total")}.
      </div>
      <div className="mr-list-box">
        <MRList searchValue={searchValue} onEntrySummaryChange={setEntrySummary} />
      </div>
      <BulkUploadInfoModal
        showModal={showBulkInfo}
        onClose={() => setShowBulkInfo(false)}
        onUpload={handleFileUpload}
        sampleFileUrl={`${process.env.PUBLIC_URL}/sample_service_bulk_upload.xlsx`}
      />
      {/* Optional: display brief summary inside modal if needed */}
    </div>
  );
};

export default ManageServicesList;
